import React from 'react';

function StoryProgress({ total, current, isPaused }) {
  return (
    <div className="story-progress">
      {Array.from({ length: total }, (_, index) => (
        <div
          key={index}
          className={`story-progress__bar ${
            index < current ? 'completed' : ''
          } ${index === current ? 'active' : ''}`}
        >
          <div
            className={`story-progress__fill ${isPaused ? 'paused' : ''}`}
            style={{
              width: index < current ? '100%' : index === current ? '100%' : '0%',
            }}
          />
        </div>
      ))}
    </div>
  );
}

export default StoryProgress;
